import 'trumbowyg/dist/trumbowyg'
import 'trumbowyg/dist/langs/cs'
import 'trumbowyg/dist/ui/trumbowyg.css'
import { getLang } from './gettext/utils'
import './../scss/trumbowyg.scss'

export function loadTrumbowyg () {
  $('.trumbowyg').each(function () {
    $(this).trumbowyg({
      svgPath: false,
      hideButtonTexts: true,
      lang: getLang(),
      btns: [
        ['viewHTML'],
        ['formatting'],
        ['strong', 'em'],
        ['link'],
        ['unorderedList', 'orderedList'],
        ['removeformat']
        // ['fullscreen']
      ],
    })
  })
}
